// extracted by mini-css-extract-plugin
export default {"notFoundPage":"NotFoundPage_notFoundPage__JN0sc","notFoundPage_home":"NotFoundPage_notFoundPage_home__7Tre0"};